import React, {useEffect, useState} from 'react';
import {Box, Button, CircularProgress, TextField, Typography, useTheme} from "@mui/material";
import ElionLogo from '../../assets/rebranding/Elion_Logo_WordmarkBaseline_RGB_Red.svg';
import {LoginLayout} from './loginLayout';
import {useTranslation} from "react-i18next";
import {CustomTheme} from "../../config/theme/theme";
import useData from "../../hooks/useData";
import useAuth from "../../hooks/useAuth";
import { useNavigate } from 'react-router-dom';

export const InstallerLogin = () => {

  const { api, storeInstallerToken, storeIsInstaller} = useData();
  const {logOut} = useAuth();
  const {authenticateApi} = api || {};
  const [loginInProgress, setLoginInProgress] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const navigate = useNavigate();

  const {t} = useTranslation();
  const theme: CustomTheme = useTheme();

  const username = React.useRef();
  const password = React.useRef();

  const login = React.useCallback(() => {
    setLoginInProgress(true);
    if (username.current && password.current) {
      authenticateApi.getTokenApiLoginPost((username.current as any).value, (password.current as any).value).then((response) => {
        storeInstallerToken(response.data.accessToken);
        navigate("/");
      }).catch((error) => {
        setErrorMessage(`${t('login.username')}/${t('login.password')} incorrect`);
      }).finally(() => {
        setLoginInProgress(false)
      });
    }
  }, [api]);

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      login();
    }
  };

  useEffect(() => {
    storeIsInstaller(true);
    logOut();
  }, []);

  return (
    <>
      <LoginLayout>
        <Box sx={{
          width: {xs: '90%', sm: '400px'},
          backgroundColor: 'white',
          borderRadius: 4,
          boxShadow: '0 0 2px rgba(0, 0, 0, 0.15)',
          padding: 2
        }}>
          <Box display="flex" justifyContent="center" mb={2}>
            <img src={ElionLogo} width='250px' alt="Elion"/>
          </Box>
          <Typography variant="h6" color={theme.palette.text.primary} fontWeight="bold">
            Login
          </Typography>
          <TextField inputRef={username} variant="outlined" placeholder={t('login.username')}
                     onKeyDown={handleKeyPress}
                     sx={{width: "100%", my: 1, input: {color: theme.palette.text.primary}, '& .MuiOutlinedInput-root': {backgroundColor: 'rgb(250, 250, 248)'}}}/>
          <TextField inputRef={password} variant="outlined" type="password" placeholder={t('login.password')}
                     onKeyDown={handleKeyPress}
                     sx={{width: "100%", my: 1, input: {color: theme.palette.text.primary}, '& .MuiOutlinedInput-root': {backgroundColor: 'rgb(250, 250, 248)'}}}/>
          {(errorMessage.length > 0) && <Typography fontSize={12} color="red">{errorMessage}</Typography>}
          <Button variant="contained" fullWidth sx={{mt: 1, mb: 2, height: '40px', textTransform: 'none'}} disabled={loginInProgress} onClick={login}>
            {loginInProgress && <CircularProgress size={18}/>}
            {!loginInProgress && <Typography color={theme.palette.text.secondary} fontWeight={600}>{t('login.login')}</Typography>}
          </Button>
        </Box>
      </LoginLayout>
    </>
  );
};
